module.exports = __webpack_public_path__ + "media/images/new_culture/factor-relationships-f934c750c899bf0b0d0ecac2b093ce5f.png";